import SingleNotification from './SingleNotification';

export default SingleNotification;
